import { render } from "./FormFile.vue?vue&type=template&id=4891b665&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4891b665"

export default script